import './mixins/contact_map';

console.log('contact.js loaded: ', Math.round(performance.now()));

let el_salon_photo = document.getElementById('js_salon-photo'),
    $lg = $('#js_light-gallery'),
    slides = $('.js_ls_img'),
    gallery = [],
    lg_options = {
        dynamic: true,
        dynamicEl: gallery,
        index: 0,
        thumbnail: true
    };

include_gallery();

[].forEach.call(slides, item => {
    gallery.push({
        src: item.dataset.fullImg,
        thumb: item.dataset.fullImg
    });
});

$lg.click(() => $lg.lightGallery(lg_options));

let el_sly = document.getElementById('js_sly');

if (el_sly) {
    new Sly(el_sly, {
        itemNav: 'basic',
        visibleItems: 4,
        mouseDragging: 1,
        touchDragging: 1,
        releaseSwing: 1,
        pagesBar: '.js_sly-box__sly-pages',
        activatePageOn: 'click',
        speed: 400,
        elasticBounds: 1,
        dragHandle: 1,
        dynamicHandle: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    visibleItems: 6
                }
            },
            {
                breakpoint: 561,
                settings: {
                    visibleItems: 4
                }
            }
        ]
    }, {
        load() {
            let clientX,
                clientY;

            slides.mousedown(event => {
                clientX = event.clientX;
                clientY = event.clientY;
            });

            slides.click(event => {
                if (clientX !== event.clientX || clientY !== event.clientY) return;

                slides.removeClass('lslide_selected');

                let slide = event.target;

                slide.classList.add('lslide_selected');
                $lg.attr('src', slide.dataset.fullImg);
                if ($lg.data('lightGallery')) $lg.data('lightGallery').destroy(true);
                lg_options.index = slides.index(slide);
            });
        }
    }).init();
}

$(window).resize(include_gallery);

function include_gallery() {
    if (document.body.clientWidth >= 992) {
        document.querySelector('.left-sidebar').insertAdjacentElement('beforeend', el_salon_photo);
    } else if (document.querySelector('.left-sidebar #js_salon-photo')) {
        document.getElementById('js_contact-map').after(el_salon_photo);
    }
}
